import { render } from "./SignOut.vue?vue&type=template&id=557afb08"
import script from "./SignOut.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SignOut.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script